import { useQuery } from '@tanstack/react-query';
import { apiGet, qk } from './_client';

/** GET /api/entitlements/film/{id} — per-film entitlement flags. */
export function useFilmEntitlements(filmId, options = {}) {
  const { enabled, ...rest } = options;
  return useQuery({
    queryKey: qk.filmEntitlements(filmId),
    queryFn: ({ signal }) => apiGet(`/entitlements/film/${filmId}`, signal),
    enabled: !!filmId && (enabled ?? true),
    ...rest,
  });
}
